import { conversationKey } from "./conversationIdentity.mjs";

export function isIncompatibleReplyReminder(reminder, trackingIndex) {
  if (reminder?.status !== "pending" || reminder?.type !== "consultant_reply_required") return false;
  const key = conversationKey(reminder.storeId, reminder.phone || reminder.telefone);
  return Boolean(key && trackingIndex?.[key]?.awaitingParty === "awaiting_client");
}